





















import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import SecureLayout from "./layouts/secure.vue";
import InSecureLayout from "./layouts/insecure.vue";
import LegalLayout from "./layouts/legal.vue";
import CleanLayout from "./layouts/clean.vue";
import EmbeddedLayout from "./layouts/embedded.vue";
import { isEmbedded, listenRedsysReturn, listenHostNavigation } from "@/shared/core/embed";
import "./js/core.min.js";
import "./js/rdnavbar.js";
import "./js/popper.js";
import "./js/jqueryeventmove.js";
import "./js/jqueryresize.js";
import "./js/pointer-events.min.js";
import GlobalError from "@/shared/components/globalError/globalError.vue";

@Component({
  components: {
    SecureLayout,
    InSecureLayout,
    LegalLayout,
    CleanLayout,
    EmbeddedLayout,
    GlobalError,
  },
})
export default class App extends Vue {
  layout: string = "";
  reload: number = 0;
  created() {
    const meta: any =
      this.$route && (this.$route as any).meta ? (this.$route as any).meta : null;
    let layout = meta && meta.layout ? meta.layout : "insecure";
    // Embebido en iframe: sin header ni footer, todo bajo el layout embedded.
    if (isEmbedded() && layout !== "clean") {
      layout = "embedded";
    }
    this.layout = layout;
    this.setDefaultReloadMessage();
  }

  mounted() {
    // Embebido: este window (el iframe) escucha el retorno del popup de Redsys y enruta
    // a la página de resultado. Allí se limpia el carrito y se avisa al host (embed.js).
    if (isEmbedded()) {
      listenRedsysReturn((status) => {
        const target = status === "ok" ? "/cz/ok" : "/cz/ko";
        if (this.$route.path !== target) {
          this.$router.push(target).catch(() => {});
        }
      });
      // El menú del tenant (Reserva/Tienda...) navega el iframe sin recargar.
      listenHostNavigation((path) => {
        if (this.$route.fullPath !== path) {
          this.$router.push(path).catch(() => {});
        }
      });
    }
  }

  setDefaultReloadMessage() {
    localStorage.setItem(
      window.location.host + "_cz_new_version_reload_message",
      this.$t("The system has been updated").toString()
    );
  }
}
